import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import MenuItem from '@material-ui/core/MenuItem'
import Box from '@material-ui/core/Box'
import Checkbox from '@material-ui/core/Checkbox'
import { useAuth } from 'lib/auth'
import { useStyles } from '../styles'

const ASSISTANT_COACHES_LABEL_WIDTH = 150

const AssistantCoaches = ({ event }) => {
  const { user } = useAuth()
  const { control, errors } = useFormContext()
  const classes = useStyles()

  const coaches = event?.academy?.coaches?.filter(coach => coach.id !== user.id)

  if (!coaches) return null

  return (
    <Box className={classes.fieldGroup}>
      <FormControl
        error={!!errors.assistantCoachIds}
        variant="outlined"
        fullWidth
        className={classes.fieldInput}
      >
        <InputLabel id="assistant-coaches-label" shrink>
          Assistant coaches
        </InputLabel>
        <Controller
          name="assistantCoachIds"
          control={control}
          render={({ onChange, value }) => (
            <Select
              labelId="assistant-coaches-label"
              multiple
              displayEmpty
              value={value || []}
              onChange={onChange}
              input={
                <OutlinedInput
                  notched
                  labelWidth={ASSISTANT_COACHES_LABEL_WIDTH}
                />
              }
              renderValue={selected => {
                if (!selected.length) {
                  return (
                    <Typography
                      component="span"
                      variant="body1"
                      color="textSecondary"
                    >
                      Search coaches by name
                    </Typography>
                  )
                }

                return selected
                  .map(id => coaches.find(coach => coach.id === id).name)
                  .join(', ')
              }}
            >
              {coaches.map(coach => (
                <MenuItem
                  key={coach.id}
                  value={coach.id}
                  data-cy="assistant-coach-menu-item"
                >
                  <Checkbox checked={(value || []).indexOf(coach.id) > -1} />
                  {coach.name}
                </MenuItem>
              ))}
            </Select>
          )}
        />
      </FormControl>
      <Typography
        className={classes.fieldHelper}
        style={{ marginTop: 8, marginBottom: 0 }}
      >
        Optional. They&apos;ll get access to attendee info.
      </Typography>
    </Box>
  )
}

export default AssistantCoaches
